import { combineReducers } from '@reduxjs/toolkit';
import { authReducer, AUTH_SLICE_NAME } from '@/modules/Auth';
import { adaptiveReducer, ADAPTIVE_SLICE_NAME } from '@/modules/Adaptive';
import { adminProfileReducer, ADMIN_PROFILE_SLICE_NAME } from '@/modules/AdminProfile';
import { usersListReducer, USERS_LIST_SLICE_NAME } from '@/modules/UsersList';
import { partnersReducer, PARTNERS_LIST_SLICE_NAME } from '@/modules/Partners';
import { LOCALES_SLICE_NAME, localesReducer } from '@/modules/Locales';
import { categoriesReducer, CATEGORIES_SLICE_NAME } from '@/modules/Categories';
import { REGIONS_SLICE_NAME, regionsReducer } from '@/modules/Regions';
import { bannersReducer, BANNERS_SLICE_NAME } from '@/modules/Banners';
import { productsReducer, PRODUCTS_SLICE_NAME } from '@/modules/Products';
import { productsImportReducer, PRODUCTS_IMPORT_SLICE_NAME } from '@/modules/ProductsImport';
import { ordersReducer, ORDERS_SLICE_NAME } from '@/modules/Orders';
import { subscriptionsReducer, SUBSCRIPTIONS_SLICE_NAME } from '@/modules/Subscriptions';
import { dashboardReducer, DASHBOARD_SLICE_NAME } from '@/modules/Dashboard';
import { seoReducer, SEO_SLICE_NAME } from '@/modules/Seo';
import { redirectsReducer, REDIRECTS_SLICE_NAME } from '@/modules/Redirects';
import { SETTINGS_SLICE_NAME, settingsReducer } from '@/modules/Settings';
import { META_TAGS_SLICE_NAME, metatagsReducer } from '@/modules/MetaTags';
import { FEEDBACKS_SLICE_NAME, feedbacksReducer } from '@/modules/Feedbacks';
import { STORES_SLICE_NAME, storesReducer } from '@/modules/Stores';
import { FEEDS_SLICE_NAME, feedsReducer } from '@/modules/Feeds';
import { COMMISSION_SLICE_NAME, commissionReducer } from '@/modules/Commission';
import { GENERATED_QR_SLICE_NAME, generatedQrReducer } from '@/modules/QrCode';
import { CONTENT_PAGES_SLICE_NAME, contentPagesReducer } from '@/modules/ContentPages';
import { STOCK_BALANCES_SLICE_NAME, stockBalancesReducer } from '@/modules/StockBalances';
import { FINANCIAL_SETTINGS_SLICE_NAME, financialSettingsReducer } from '@/modules/FinancialSettings';
import { cancelledOrdersReducer, CANCELLED_ORDERS_SLICE_NAME } from '@/modules/CancelledOrders';

export const rootReducer = combineReducers({
  [AUTH_SLICE_NAME]: authReducer,
  [ADAPTIVE_SLICE_NAME]: adaptiveReducer,
  [USERS_LIST_SLICE_NAME]: usersListReducer,
  [ADMIN_PROFILE_SLICE_NAME]: adminProfileReducer,
  [PARTNERS_LIST_SLICE_NAME]: partnersReducer,
  [LOCALES_SLICE_NAME]: localesReducer,
  [CATEGORIES_SLICE_NAME]: categoriesReducer,
  [REGIONS_SLICE_NAME]: regionsReducer,
  [BANNERS_SLICE_NAME]: bannersReducer,
  [PRODUCTS_IMPORT_SLICE_NAME]: productsImportReducer,
  [PRODUCTS_SLICE_NAME]: productsReducer,
  [ORDERS_SLICE_NAME]: ordersReducer,
  [SUBSCRIPTIONS_SLICE_NAME]: subscriptionsReducer,
  [DASHBOARD_SLICE_NAME]: dashboardReducer,
  [CANCELLED_ORDERS_SLICE_NAME]: cancelledOrdersReducer,
  [SEO_SLICE_NAME]: seoReducer,
  [REDIRECTS_SLICE_NAME]: redirectsReducer,
  [SETTINGS_SLICE_NAME]: settingsReducer,
  [META_TAGS_SLICE_NAME]: metatagsReducer,
  [FEEDBACKS_SLICE_NAME]: feedbacksReducer,
  [STORES_SLICE_NAME]: storesReducer,
  [FEEDS_SLICE_NAME]: feedsReducer,
  [COMMISSION_SLICE_NAME]: commissionReducer,
  [GENERATED_QR_SLICE_NAME]: generatedQrReducer,
  [CONTENT_PAGES_SLICE_NAME]: contentPagesReducer,
  [STOCK_BALANCES_SLICE_NAME]: stockBalancesReducer,
  [FINANCIAL_SETTINGS_SLICE_NAME]: financialSettingsReducer,
});
